module.exports = __webpack_public_path__ + "img/code.000988ac.png";